import { useQuery } from "@tanstack/react-query";

import { LocalStorageKeys } from "@/common/constants";
import userApi from "@/types/user/userApi";
import { callApi } from "@/Utils/request/query";

import { loadSessionUser } from "./loadSessionUser";
import { refreshSession } from "./refreshSession";

export function useSessionUserQuery(
  accessToken: string | null,
  ownerId?: string,
) {
  return useQuery({
    queryKey: ["currentUser", accessToken],
    queryFn: ({ signal }) =>
      loadSessionUser({
        signal,
        expectedOwnerId: ownerId,
        getAccessToken: () =>
          localStorage.getItem(LocalStorageKeys.accessToken),
        refresh: refreshSession,
        readUser: (access, boundedSignal) =>
          callApi(
            { ...userApi.currentUser, noAuth: true },
            {
              headers: { Authorization: `Bearer ${access}` },
              silent: true,
              signal: boundedSignal,
            },
          ),
      }),
    retry: false,
    enabled: !!accessToken,
  });
}
